import useSWR from "swr";
import clsx from "clsx";
import { useNavigate } from "react-router";
import { useTranslation, Trans } from "react-i18next";
import { fetchUserRebate } from "~/api/endpoints";
import { Page } from "~/components/Page/Page";
import {
    IconWalletFill,
    IconLoading,
    IconGift,
    IconProfit,
} from "~/components";
import { useUXUYWallet } from "~/Provider/UXUYWallet";
import LottieSticker from "~/components/LottieSticker";
import InviteBar from "./components/InviteBar";
import InviteCard from "./components/InviteCard";
import RebateAndInviteList from "./components/RebateAndInviteList/RebateAndInviteList";
import { config } from "~/config";
import { skdUtils } from "~/utils/tgLink";
import { openTelegramLink } from "@telegram-apps/sdk-react";

export default function ReabtePage() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { isConnected, connect, isConnecting } = useUXUYWallet();
    const { data } = useSWR("api_rebate", fetchUserRebate);

    const { rate = 0 } = data?.data || {};
    const isConnect = isConnected();

    const goToWallet = () => {
        const showTip = localStorage.getItem(
            "__uxuy_dex_cached_show_modal_gift_invite_new_user_intro__"
        );

        const params = {
            path: `/gift-packet/create`,
            route_replace: "1",
            userTypeForAllowClaim: 1,
            showNewUserIntro: showTip ? 0 : 1,
        };

        localStorage.setItem(
            "__uxuy_dex_cached_show_modal_gift_invite_new_user_intro__",
            "1"
        );

        const link = `${config.wallet_direct_link}?startapp=D_${skdUtils.encodeTelegramUrlParameters(params || {})}`;
        openTelegramLink(link);
    };

    return (
        <Page>
            <div className="bg-bg_0 pt-4 pb-5">
                <div className="px-4">
                    <div className="w-[120px] h-[120px] mx-auto mt-[20px]">
                        <LottieSticker
                            lottieName="rebate"
                            className="w-[120px] h-[120px]"
                        />
                    </div>
                    <div className="text-center text-h4 font-Semibold text-text_1 mt-[10px]  whitespace-break-spaces ">
                        <Trans
                            defaults={"rebate_title"}
                            values={{ num: `${rate}%` }}
                            components={{
                                span: <span className="text-text_brand" />,
                            }}
                        />
                    </div>
                    <div
                        className={clsx(
                            "bg-AlphaOrange dark:bg-DarkAlphaOrange rounded-[12px]",
                            {
                                hidden: isConnect,
                            }
                        )}
                    >
                        <div
                            className="relative flex bg-Orange h-[54px] flex-1 mt-[12px] rounded-[12px] text-center text-h6 font-Semibold text-white  items-center py-[15px] px-[12px] cursor-pointer"
                            onClick={connect}
                        >
                            {isConnecting ? (
                                <IconLoading className="absolute text-[24px] text-white" />
                            ) : (
                                <IconWalletFill className="absolute text-[24px] text-white" />
                            )}
                            <span className="text-h6 text-center text-White font-Semibold flex-grow">
                                {t("connect_wallet")}
                            </span>
                        </div>
                        <div className="rounded-[12px] px-[12px] py-[8px] text-text_brand text-body3 font-Regular text-center">
                            {t("rebate_desc")}
                        </div>
                    </div>
                    <div className={clsx({ hidden: !isConnect })}>
                        <InviteBar className="mt-[12px]" />
                        <InviteCard data={data?.data} />
                        <div className="flex items-center gap-2 mt-2">
                            <div
                                className={clsx(
                                    "flex-1 h-13.5 flex items-center justify-center",
                                    "rounded-[12px] bg-AlphaOrange dark:bg-DarkAlphaOrange cursor-pointer"
                                )}
                                onClick={goToWallet}
                            >
                                <IconGift className="text-h5 text-text_brand mr-2 -mt-0.5" />
                                <span className="text-body4 text-text_brand font-semibold">
                                    {t("rebate_gift_invite")}
                                </span>
                            </div>
                            <div
                                className={clsx(
                                    "flex-1 h-13.5 flex items-center justify-center",
                                    "rounded-[12px] bg-AlphaOrange dark:bg-DarkAlphaOrange cursor-pointer"
                                )}
                                onClick={() => {
                                    navigate("/profit-tips");
                                }}
                            >
                                <IconProfit className="text-h5 text-text_brand mr-2 -mt-0.5" />
                                <span className="text-body4 text-text_brand font-semibold">
                                    {t("rebate_profit_tips")}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="mt-[20px]">
                        <RebateAndInviteList rate={rate} />
                    </div>
                </div>
            </div>
        </Page>
    );
}
